import styled from 'styled-components';

export const NameFormContainer = styled.div`
  display: flex;
`;

export const InfoText = styled.span`
  color: ${({ theme }) => theme.white.a10};
`;

export const SignUpForm = styled.form`
  max-width: 325px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const SignupSuccessTitle = styled.h1`
  font-size: 25px;
  font-weight: 300;
  max-width: 263px;
  line-height: 35px;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin: 10px 0;
`;

export const SignupSuccessSubTitle = styled.h2`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  max-width: 385px;
`;

export const FormSubTitle = styled.div`
  color: ${({ theme }) => theme.white.a10};
  font-size: 1rem;
  padding: 1rem;
  text-align: center;
`;

export const SignUpSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InfoBox = styled.span`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.3px;
`;
